import { SVGProps } from 'react'

export const Shield = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 18.967c-.908 0-1.808-.267-2.517-.792L3.9 15.5c-.95-.708-1.692-2.183-1.692-3.367v-6.2c0-1.283.942-2.65 2.15-3.1l4.159-1.558c.825-.308 2.125-.308 2.95 0l4.166 1.558c1.209.45 2.15 1.817 2.15 3.1v6.192c0 1.183-.741 2.658-1.691 3.367l-3.584 2.675c-.7.533-1.6.8-2.508.8ZM8.958 2.45 4.8 4.008c-.717.267-1.342 1.167-1.342 1.934v6.191c0 .792.559 1.9 1.184 2.367l3.583 2.675c.958.717 2.583.717 3.542 0L15.35 14.5c.633-.475 1.183-1.583 1.183-2.367v-6.2c0-.758-.625-1.658-1.341-1.933l-4.159-1.558c-.55-.2-1.516-.2-2.075.008Z"
      fill="currentColor"
    />
    <path
      d="M10 11.042A2.29 2.29 0 0 1 7.708 8.75 2.29 2.29 0 0 1 10 6.458a2.29 2.29 0 0 1 2.292 2.292A2.29 2.29 0 0 1 10 11.042Zm0-3.334a1.042 1.042 0 1 0 0 2.084 1.042 1.042 0 0 0 0-2.084Z"
      fill="currentColor"
    />
    <path
      d="M10 13.542a.63.63 0 0 1-.625-.625v-2.5A.63.63 0 0 1 10 9.792a.63.63 0 0 1 .625.625v2.5a.63.63 0 0 1-.625.625Z"
      fill="currentColor"
    />
  </svg>
)
